import React from 'react';

import { FilterSelect, Filters } from 'filters';
import FiltersContext from 'filters/FiltersContext';
import {
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_CAMPAIGNS,
  FILTER_CHANNELS,
  FILTER_MANAGERS,
  FILTER_NETWORKS,
  FILTER_OWNERS,
  FILTER_PERIOD,
  FILTER_PLATFORMS,
  FILTER_TRAFFIC_TYPE,
} from 'scenes/PerformancePage/constants';
import { loadAffiliates } from 'scenes/PerformancePage/sources/filters/loadAffiliates';
import { loadApplications } from 'scenes/PerformancePage/sources/filters/loadApplications';
import { loadCampaigns } from 'scenes/PerformancePage/sources/filters/loadCampaigns';
import { loadChannels } from 'scenes/PerformancePage/sources/filters/loadChannels';
import { loadManagers } from 'scenes/PerformancePage/sources/filters/loadManagers';
import { loadNetworks } from 'scenes/PerformancePage/sources/filters/loadNetworks';
import { loadOwners } from 'scenes/PerformancePage/sources/filters/loadOwners';
import { loadPeriods } from 'scenes/PerformancePage/sources/filters/loadPeriods';
import { loadPlatforms } from 'scenes/PerformancePage/sources/filters/loadPlatforms';
import { loadTrafficTypes } from 'scenes/PerformancePage/sources/filters/loadTrafficTypes';

const DEPENDENCIES = {
  [FILTER_TRAFFIC_TYPE]: [],
  [FILTER_PERIOD]: [],
  [FILTER_APPLICATIONS]: [],
  [FILTER_NETWORKS]: [FILTER_APPLICATIONS],
  [FILTER_AFFILIATES]: [FILTER_APPLICATIONS, FILTER_NETWORKS, FILTER_CHANNELS],
  [FILTER_CAMPAIGNS]: [FILTER_AFFILIATES],
  [FILTER_OWNERS]: [
    FILTER_APPLICATIONS,
    FILTER_NETWORKS,
    FILTER_AFFILIATES,
    FILTER_MANAGERS,
    FILTER_CHANNELS,
  ],
  [FILTER_MANAGERS]: [
    FILTER_APPLICATIONS,
    FILTER_NETWORKS,
    FILTER_AFFILIATES,
    FILTER_OWNERS,
    FILTER_CHANNELS,
  ],
  [FILTER_PLATFORMS]: [FILTER_NETWORKS, FILTER_APPLICATIONS],
  [FILTER_CHANNELS]: [
    FILTER_APPLICATIONS,
    FILTER_AFFILIATES,
    FILTER_NETWORKS,
    FILTER_PLATFORMS,
    FILTER_MANAGERS,
    FILTER_OWNERS,
  ],
};

const FiltersModal = ({
  initialValues = {},
  defaultValues = {},
  onSubmit,
  onClose,
}: any) => {
  return (
    <Filters
      initialValues={initialValues}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onClose={onClose}
    >
      <FilterSelect
        label={'Period'}
        name={FILTER_PERIOD}
        source={loadPeriods}
        depends={DEPENDENCIES[FILTER_PERIOD]}
        clearableBlock={true}
      />
      <FilterSelect
        label={'Applications'}
        name={FILTER_APPLICATIONS}
        source={loadApplications}
        multiple={true}
        depends={DEPENDENCIES[FILTER_APPLICATIONS]}
        clearable={true}
      />
      <FilterSelect
        multiple={true}
        label={'Affiliates'}
        name={FILTER_AFFILIATES}
        source={loadAffiliates}
        depends={DEPENDENCIES[FILTER_AFFILIATES]}
        clearable={true}
      />

      <FiltersContext.Consumer>
        {({ values }: any) => {
          return (
            <FilterSelect
              multiple={true}
              label={'Campaigns'}
              helper={'Select affiliate first'}
              name={FILTER_CAMPAIGNS}
              source={loadCampaigns}
              depends={DEPENDENCIES[FILTER_CAMPAIGNS]}
              active={values[FILTER_AFFILIATES]?.length > 0}
              clearable={true}
            />
          );
        }}
      </FiltersContext.Consumer>
      <FilterSelect
        label={'Traffic Type'}
        name={FILTER_TRAFFIC_TYPE}
        source={loadTrafficTypes}
        depends={DEPENDENCIES[FILTER_TRAFFIC_TYPE]}
        clearableBlock={true}
      />
      <FilterSelect
        label={'Networks'}
        multiple={true}
        name={FILTER_NETWORKS}
        source={loadNetworks}
        depends={DEPENDENCIES[FILTER_NETWORKS]}
        clearable={true}
      />

      <FilterSelect
        label={'Channels'}
        multiple={true}
        name={FILTER_CHANNELS}
        source={loadChannels}
        depends={DEPENDENCIES[FILTER_CHANNELS]}
        clearable={true}
      />

      <FilterSelect
        label={'Platforms'}
        multiple={true}
        name={FILTER_PLATFORMS}
        source={loadPlatforms}
        depends={DEPENDENCIES[FILTER_PLATFORMS]}
        clearable={true}
      />
      <FilterSelect
        label={'Owners'}
        multiple={true}
        name={FILTER_OWNERS}
        source={loadOwners}
        depends={DEPENDENCIES[FILTER_OWNERS]}
        clearable={true}
      />
      <FilterSelect
        label={'Managers'}
        multiple={true}
        name={FILTER_MANAGERS}
        source={loadManagers}
        depends={DEPENDENCIES[FILTER_MANAGERS]}
        clearable={true}
      />
    </Filters>
  );
};

export default FiltersModal;
